export default __webpack_public_path__ + "static/media/pictogramBeaconBNPL128.d35d9d58.svg";